import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';

export class HcfOperationalReportApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/HcfOperationalReport`;

    public static apiUrls = {
        downloadPdf: `${HcfOperationalReportApi.baseApiUrl}/HealthcareFacility`,
    };

    public static async downloadPdf(healthcareFacilityId: number): Promise<Blob> {
        return this.sendApiRequest<Blob>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.downloadPdf}/${healthcareFacilityId}`,
            extraOptionsConfig: { responseType: 'blob' },
        });
    }
}
